import Icon from "../../Icon";
import "./index.css";

interface HeaderOptionsProps {
  onClickHome?: () => void;
  onClickReel?: () => void;
}

const HeaderOptions = (props: HeaderOptionsProps) => {
  const { onClickHome = null, onClickReel = null } = props;

  return (
    <>
      {(onClickHome !== null || onClickReel !== null) && (
        <div className="base-header-options">
          {onClickHome !== null && (
            <div onClick={onClickHome} className="base-header-option">
              <Icon type="home" />
            </div>
          )}
          {onClickReel !== null && (
            <div onClick={onClickReel} className="base-header-option">
              <Icon type="reel" />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default HeaderOptions;
